import { render, staticRenderFns } from "./DynamicFormItem.vue?vue&type=template&id=61646936&scoped=true"
import script from "./DynamicFormItem.vue?vue&type=script&lang=js"
export * from "./DynamicFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61646936",
  null
  
)

export default component.exports